import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import CloseIcon from '@icons/CloseIcon';
import CompanyFilters from '../CompanyFilters';
import MemberFilters from '../MemberFilters';
import CurrentFilters from '../../elements/CurrentFilters';
import { SearchTypeContext } from '../../../context/searchTypeContext';
import ArticleFilters from '../ArticleFilters';
import EventFilters from '../EventFilters';

const FiltersOverlay = ({ open, onClose }) => {
    const [searchType] = useContext(SearchTypeContext);
    const containerStyles = {
        ...styles.container,
        visibility: open ? 'visible' : 'hidden',
    };

    return (
        <div style={containerStyles}>
            <div style={styles.header}>
                <h1 className="mb-0">Filter Results</h1>
                <h2 className="mb-0">
                    <button
                        type="button"
                        onClick={onClose}
                        style={{ WebkitAppearance: 'none', border: 'none', background: 'transparent' }}
                    >
                        <CloseIcon />
                    </button>
                </h2>
            </div>

            <div style={styles.body}>
                <div className="pb-4" style={styles.currentFiltersContainer}>
                    <CurrentFilters buttonClasses="display8" clearAllClasses="display9" useButtons onClose={onClose} />
                </div>

                {searchType.index === 'members' && <MemberFilters />}
                {searchType.index === 'companies' && <CompanyFilters />}
                {searchType.index === 'articles' && <ArticleFilters />}
                {searchType.index === 'events' && <EventFilters />}
            </div>
        </div>
    );
};

FiltersOverlay.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};

const styles = {
    container: {
        background: '#fff',
        bottom: 0,
        left: 0,
        position: 'fixed',
        right: 0,
        top: 0,
        zIndex: 99999,
    },
    header: {
        backgroundColor: '#323333',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        height: '58px',
        left: 0,
        padding: '10px 20px',
        position: 'fixed',
        right: 0,
    },
    body: {
        bottom: 0,
        left: 0,
        overflow: 'scroll',
        padding: '20px',
        position: 'fixed',
        right: 0,
        top: '58px',
    },
    currentFiltersContainer: {
        borderBottom: '1px solid #000',
    },
};

export default FiltersOverlay;
